import { render } from "./screenItem.vue?vue&type=template&id=dff4d964&scoped=true"
import script from "./screenItem.vue?vue&type=script&lang=js"
export * from "./screenItem.vue?vue&type=script&lang=js"

import "./screenItem.vue?vue&type=style&index=0&id=dff4d964&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff4d964"]])

export default __exports__